<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.gamification_sets', 2),
                        href: meta.links.set_index,
                    },
                    {
                        name: gamificationSet.breadcrumb_title,
                        href: meta.links.set_show,
                    },
                    {
                        name: $tc('messages.fetch_quests', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.create'),
                        href: null,
                    },
                ]"
            />
        </template>

        <FetchQuestForm :fetch-quest="fetchQuest" :options="options" :url="meta.links.store" />
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import FetchQuestForm from '@/Pages/Teacher/Gamification/FetchQuests/partials/FetchQuestForm.vue';

export default {
    components: {
        FetchQuestForm,
        PanelPage,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'options', 'fetchQuest', 'gamificationSet'],
};
</script>
